import React, {useState} from "react";
import classes from "./pay3.module.css";

// Тексты инструкций для каждого шага
const instructionSteps = {
    sber: [
        "Нажмите 'Платежи' в нижнем меню приложения",
        "В поле перевести выберите 'В другую страну'",
        "Выберите старну перевода",
        "Нажмите на пункт 'На карту или счёт'",
        "Укажите номер карты",
        "Укажите ФИО и сумму для перевода",
        "Нажмите оплатить"
    ],
    tbank: [
        "Нажмите 'Платежи' на главном экране",
        "Выберите 'По номеру карты' в разделе переводов",
        "Введите имя получателя и выберите валюту перевода",
        "Проверьте данные и нажмите 'Перевести'"
    ]
};

export default function InstructionCarousel({bank, images}) {
    const [currentStep, setCurrentStep] = useState(0);
    const steps = instructionSteps[bank] || [];

    if (!images || !images.length || !steps.length) {
        return null;
    }

    const goToNext = () => {
        setCurrentStep((prev) => (prev + 1) % images.length);
    };

    const goToPrev = () => {
        setCurrentStep((prev) => (prev - 1 + images.length) % images.length);
    };

    const goToStep = (index) => {
        setCurrentStep(index);
    };

    return (
        <div className={classes.CarouselContainer}>
            <div className={classes.CarouselHeader}>
                <div className={classes.CarouselTitle}>
                    Шаг {currentStep + 1} из {images.length}
                </div>
                <div className={classes.CarouselStepText}>
                    {steps[currentStep]}
                </div>
            </div>

            <div className={classes.CarouselImageWrapper}>
                <img
                    src={images[currentStep]}
                    alt={`Шаг ${currentStep + 1}`}
                    className={classes.CarouselImage}
                />
            </div>

            <div className={classes.CarouselControls}>
                <button
                    type="button"
                    onClick={goToPrev}
                    className={classes.CarouselArrow}
                    disabled={images.length <= 1}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M15 18l-6-6 6-6"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>

                <div className={classes.CarouselDots}>
                    {images.map((_, idx) => (
                        <button
                            key={idx}
                            type="button"
                            onClick={() => goToStep(idx)}
                            className={
                                idx === currentStep
                                    ? classes.CarouselDotActive
                                    : classes.CarouselDot
                            }
                            aria-label={`Перейти к шагу ${idx + 1}`}
                        />
                    ))}
                </div>

                <button
                    type="button"
                    onClick={goToNext}
                    className={classes.CarouselArrow}
                    disabled={images.length <= 1}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M9 18l6-6-6-6"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/PagesOfCommon/Pay3/InstructionCarousel.jsx